function containsAny(str, substrings) {
    if (substrings !== undefined) {
        for (var i = 0; i !== substrings.length; i++) {
            var substring = substrings[i];
            if (str.indexOf(substring) !== - 1) {
                return true;
            }
        }
        return false;
    }

    return true;
}

function countChars(str) {
    let count = 0;

    for(let i = 0; i < str.length; i++){
        if (str[i].match(/[a-z]/i)){
            count += 1;
        }
    }

    return count;
}

function capsPostcode(str, maxCharslength) {
    var allValues = ["all", "tout", "alles", "todos", "tutti"];

    if (str !== undefined) {
        if (str && countChars(str) <= maxCharslength && !containsAny(str, allValues)) {
            return str.toUpperCase();
        }
    }

    return str.toLowerCase();
}

export default {
    containsAny,
    capsPostcode,
    countChars,
}